import { DiscountTypes } from "@/common/enums";

export default class NorthStarSiteSettingsModel {
    endPoint: string = "";
    validationCode: string = "";
    publicKey: string = "";
    useProxy: boolean = false;
}
